var map = {
	"./main/typeshed.en copy.json": [
		2837,
		837
	],
	"./main/typeshed.en.json": [
		3052,
		52
	],
	"./main/typeshed.es-es.json": [
		7727,
		727
	],
	"./main/typeshed.fr.json": [
		4524,
		524
	],
	"./main/typeshed.ja.json": [
		4867,
		867
	],
	"./main/typeshed.ko.json": [
		3460,
		460
	],
	"./main/typeshed.nl.json": [
		5540,
		540
	],
	"./main/typeshed.zh-cn copy.json": [
		5733,
		733
	],
	"./main/typeshed.zh-cn.json": [
		2192,
		192
	],
	"./main/typeshed.zh-tw.json": [
		9450,
		450
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3160;
module.exports = webpackAsyncContext;